import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError, } from 'rxjs/operators';
import { User } from '../types/User';
import { EnvService } from '../services/env.service';


const BASE_URL = "http://localhost:3000/users"; 
const BASE_URL2 = "http://localhost:3000/user-types"; 
const BASE_URL3 = "http://localhost:3000/user-permission";
const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };


@Injectable({
  providedIn: 'root'
})
export class UserService {
  dataRow : any;
  resetRequestDataRow :any;
  mailData :any;


  constructor(private http: HttpClient,private env: EnvService) { }

  getAll():Observable <User[]> {
    return this.http.get<User[]>(`${this.env.apiUrl}/users`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    addUser(user: User):Observable <User>{
      return this.http.post<User>(`${this.env.apiUrl}/users`,  user ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    changePassword(data): Observable<any> {
      return this.http.put(`${this.env.apiUrl}/users/changePassword`,data, httpOptions)
      .pipe(catchError(this.handleError));    
    }
    
    updateUser(data: User):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/users`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteUser(id: number) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/users/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    ///////// USER TYPES
    getAllUserTypes():Observable <any[]> {
      return this.http.get<any[]>(`${this.env.apiUrl}/user-types`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

      addUserType(data):Observable <any>{
        return this.http.post<any>(`${this.env.apiUrl}/user-types`,  data ,httpOptions)
          .pipe(catchError(this.handleError));
         
      }
     
  
      deleteUserType(id: number) : Observable <void>{
        return this.http.delete<void>(`${this.env.apiUrl}/user-types/${id}`,httpOptions)
          .pipe(catchError(this.handleError));
         
      }
  

      ///////// USER PERMISSION

      getUserPermission(userName:string):Observable <any> {
        return this.http.get<any>(`${this.env.apiUrl}/user-permission/${userName}`,httpOptions)
        .pipe(catchError(this.handleError));
           
        }
  
        addUserPermission(data):Observable <any>{
          return this.http.post<any>(`${this.env.apiUrl}/user-permission`,  data ,httpOptions)
            .pipe(catchError(this.handleError));
           
        }
       
        updateUserPermission(data):Observable <void>{
          return this.http.put<void>(`${this.env.apiUrl}/user-permission`, data ,httpOptions)
            .pipe(catchError(this.handleError));
           
        }
    
        deleteUserPermission(id: number) : Observable <void>{
          return this.http.delete<void>(`${this.env.apiUrl}/user-permission/${id}`,httpOptions)
            .pipe(catchError(this.handleError));
           
        }

      //   user control permission

        addControlPermission(data):Observable <any>{
          return this.http.post<any>(`${this.env.apiUrl}/user-control-permission`,  data ,httpOptions)
            .pipe(catchError(this.handleError));
           
        }

        deleteControlPermission(username: string) : Observable <void>{
          return this.http.delete<void>(`${this.env.apiUrl}/user-control-permission/${username}`,httpOptions)
            .pipe(catchError(this.handleError));
           
        }

        getControlPermission(username:string):Observable <any> {
          return this.http.get<any>(`${this.env.apiUrl}/user-control-permission/${username}`,httpOptions)
          .pipe(catchError(this.handleError));
             
          }

            //   Reset Password

            resetPasswordRequest(data):Observable <any>{
              return this.http.post<any>(`${this.env.apiUrl}/users/reset-password-request`,  data ,httpOptions)
                .pipe(catchError(this.handleError));           
             }
  
  
             getAllRequestList():Observable <any[]> {
              return this.http.get<any[]>(`${this.env.apiUrl}/users/request-list`,httpOptions)
              .pipe(catchError(this.handleError));
                 
              }
  
              resetPassword(data):Observable <any>{
                return this.http.put<any>(`${this.env.apiUrl}/users/reset-password`,  data ,httpOptions)
                  .pipe(catchError(this.handleError));           
               }
  
               deleteResetRequest(id: number) : Observable <void>{
                return this.http.delete<void>(`${this.env.apiUrl}/users/delete-reset-request/${id}`,httpOptions)
                  .pipe(catchError(this.handleError));
                 
              }
          
    
  

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }




}
